import { FaClock, FaMapMarkerAlt, FaUserTie, FaDollarSign, FaTags, FaBriefcase, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaShieldAlt, FaWrench, FaHeadset, FaCarSide, FaCrown, FaTruckPickup, FaHeart, FaPlaneDeparture, FaCar, FaTruck, FaTasks, FaTruckLoading, FaSun, FaMountain, FaBoxes, FaTachometerAlt, FaUserFriends, FaRoad, FaGasPump, FaCogs, FaCheckCircle, FaBolt, FaSnowflake, FaPalette, FaSuitcaseRolling, FaHourglass } from 'react-icons/fa';



// Function to render the appropriate icon based on the service name
export const renderIcon = (iconName) => {

  // Convert the service name to lowercase
  const lowercaseServiceName = iconName.toLowerCase();

  // Check the lowercase service name and return the corresponding icon component
  switch (lowercaseServiceName) {

    /*----- Service Icons -----*/
    case 'economy car':
      return <FaCarSide />; // Icon representing an economy car

    case 'luxury car':
      return <FaCrown />; // Icon representing a luxury car

    case 'suv rental':
      return <FaTruckPickup />; // Icon representing an SUV rental

    case 'wedding rental':
      return <FaHeart />; // Icon representing wedding car rental

    case 'lengthy rentals':
      return <FaCalendarAlt />; // Icon representing long-term or lengthy rentals

    case 'airport transfer':
      return <FaPlaneDeparture />; // Icon representing airport transfer service

    /*----- Position Icons -----*/
    case 'rental sales agent':
      return <FaCar />; // Icon representing a rental sales agent

    case 'customer support':
      return <FaHeadset />; // Icon representing customer support service

    case 'fleet manager':
      return <FaTruck />; // Icon representing a fleet manager

    case 'vehicle inspector':
      return <FaWrench />; // Icon representing a vehicle inspector

    case 'operation coordinator':
      return <FaTasks />; // Icon representing an operations coordinator

    case 'delivery specialist':
      return <FaTruckLoading />; // Icon representing a delivery specialist

    /*----- Car Category Icons -----*/
    case 'sedan':
      return <FaCarSide />; // Represents a standard sedan vehicle

    case 'convertible':
      return <FaSun />; // Represents open-top cars and sunny drives

    case 'suv':
      return <FaMountain />; // Represents rugged terrain and adventure

    case 'hatchback':
      return <FaBoxes />; // Represents compact utility and cargo flexibility

    case 'sports car':
      return <FaTachometerAlt />; // Represents high speed and performance

    case 'truck':
      return <FaTruck />; // Represents large cargo capacity

    case 'minivan':
      return <FaUserFriends />; // Represents family and group travel

    case 'coupe':
      return <FaRoad />; // Represents stylish design and road presence

    /*----- Car Details Icons -----*/
    case 'brand':
      return <FaCarSide />; // Represents the car brand or model
  
    case 'type':
      return <FaCar />; // Represents the vehicle type or category
  
    case 'fueltype':
      return <FaGasPump />; // Represents fuel type like petrol, diesel, electric
  
    case 'transmission':
      return <FaCogs />; // Represents automatic/manual transmission
  
    case 'costpermile':
      return <FaDollarSign />; // Represents cost efficiency or mileage rate
  
    case 'availability':
      return <FaCheckCircle />; // Represents availability status
  
    case 'maxspeed':
      return <FaTachometerAlt />; // Represents top speed of the vehicle
  
    case 'power':
      return <FaBolt />; // Represents engine power or horsepower
  
    case 'range':
      return <FaRoad />; // Represents driving range (esp. for EVs)
  
    case 'climatecontrol':
      return <FaSnowflake />; // Represents A/C or climate control features
  
    case 'safetyfeatures':
      return <FaShieldAlt />; // Represents safety and protection features
  
    case 'coloroptions':
      return <FaPalette />; // Represents available color variations
  
    case 'year':
      return <FaCarSide />; // Represents model year
  
    case 'seats':
      return <FaUserFriends />; // Represents passenger seating capacity
  
    case 'suitcase':
      return <FaSuitcaseRolling />; // Represents suitcase capacity (like in booking forms)


    /*----- Page Sidebar -----*/
    case 'date':
    case 'days':
    case 'deadline':
      return <FaCalendarAlt />; // Calendar icon representing date and deadlines

    case 'timing':
    case 'hours':
    case 'time':
      return <FaClock />; // Clock icon representing time and schedules

    case 'duration':
      return <FaHourglass />; // Hour Glass icon representing the duration of an event or task

    case 'client':
    case 'position':
      return <FaUsers />; // Users icon representing individuals in a position or client

    case 'category':
      return <FaTags />; // Tags icon representing different service categories

    case 'location':
      return <FaMapMarkerAlt />; // Map marker icon representing physical locations

    case 'salary':
    case 'cost':
    case 'fee':
      return <FaDollarSign />; // Dollar sign icon representing costs, fee, or salary

    case 'experience':
      return <FaBriefcase />; // Briefcase icon representing work experience

    case 'projectlead':
    case 'organizer':
      return <FaUserTie />; // User Tie icon representing a project lead and organizer

    case 'number':
      return <FaPhone />; // Phone icon representing contact numbers

    case 'email':
      return <FaEnvelope />; // Envelope icon representing email communication

    default:
      return null; // Return null if no matching icon is found
  }
};